import { AUTHORSEARCH, CATEGORYSEARCH, CLEARSEARCH, GENERALSEARCH } from "./actionTypes";
import { initialState } from "./initialState";

export const blogReducer = (state = initialState, action) => {
    switch(action.type) {
        case CATEGORYSEARCH: {
            return state.filter(blog => blog.category === action.payload);
        }
        case AUTHORSEARCH: {
            return state.filter(blog => blog.author.id === action.payload);
        }
        case GENERALSEARCH: {
            return initialState.filter(blog => blog.title?.toLowerCase().includes(action.payload?.toLowerCase()));
        }
        case CLEARSEARCH: {
            return initialState;
        }
        default: {
            return state;
        }
    }
};